namespace $.$$ {

	export class $shm_hitalama_taskmanager_card extends $.$shm_hitalama_taskmanager_card {

		statuses(): readonly $shm_hitalama_taskmanager_status[] {
			return [ 'todo', 'progress', 'done' ]
		}

		title( next?: string ) {
			const task = this.task() as $shm_hitalama_taskmanager_task | null
			if( next === undefined ) return task?.title ?? ''
			if( task ) this.task({ ... task, title: next })
			return next
		}

		priority( next?: string ) {
			const task = this.task() as $shm_hitalama_taskmanager_task | null
			if( next === undefined ) return task?.priority ?? 'normal'
			if( task ) this.task({ ... task, priority: next as $shm_hitalama_taskmanager_task_priority })
			return next
		}

		created_at_label() {
			const task = this.task() as $shm_hitalama_taskmanager_task | null
			if( !task ) return ''

			const time = task.status === 'todo' ? task.created_at : task.status_changed_at ?? task.created_at
			return new Date( time ).toLocaleString( 'ru-RU', {
				day: '2-digit',
				month: '2-digit',
				year: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
			} )
		}

		previous_enabled() {
			return ( this.task() as $shm_hitalama_taskmanager_task | null )?.status !== 'todo'
		}

		next_enabled() {
			return ( this.task() as $shm_hitalama_taskmanager_task | null )?.status !== 'done'
		}

		@ $mol_mem
		focus_auto() {
			const task = this.task() as $shm_hitalama_taskmanager_task | null
			if( !task?.focus ) return null

			new this.$.$mol_after_frame( ()=> {
				this.Title().Edit().focused( true )

				const current = this.task() as $shm_hitalama_taskmanager_task | null
				if( current?.id !== task.id || !current.focus ) return

				this.task({ ... current, focus: false })
			} )

			return task.id
		}

		task_shift( diff: number ) {
			const task = this.task() as $shm_hitalama_taskmanager_task | null
			if( !task ) return

			const statuses = this.statuses()
			const index = statuses.indexOf( task.status )
			const status = statuses[ index + diff ]
			if( !status ) return

			this.task({ ... task, status, status_changed_at: Date.now() })
		}

		@ $mol_action
		move_left( next?: Event ) {
			if( next === undefined ) return null
			this.task_shift( -1 )
			return next
		}

		@ $mol_action
		move_right( next?: Event ) {
			if( next === undefined ) return null
			this.task_shift( 1 )
			return next
		}

		@ $mol_action
		delete( next?: Event ) {
			if( next === undefined ) return null
			this.task( null )
			return next
		}

	}

}
